import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ebbaa0b2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ebbaa0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbaa0b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsAsideCategories: require('/web/components/objects/AsideCategories.vue').default,LinkedObjectPublic: require('/web/components/LinkedObjectPublic.vue').default,AboutAuthor: require('/web/components/AboutAuthor.vue').default})
